import { render, staticRenderFns } from "./ReferPatientForm.vue?vue&type=template&id=f5482e32&scoped=true"
import script from "./ReferPatientForm.vue?vue&type=script&lang=js"
export * from "./ReferPatientForm.vue?vue&type=script&lang=js"
import style0 from "./ReferPatientForm.vue?vue&type=style&index=0&id=f5482e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5482e32",
  null
  
)

export default component.exports